export default __webpack_public_path__ + "static/media/pg-36.2dcd5d08.jpg";